import { useBorrowDialog } from './logic/useBorrowDialog'
import { BorrowView } from './views/BorrowView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface BorrowDialogContentContainerProps {
  reserve: Reserve
  initialBorrowToken: SparkLendToken
  closeDialog: () => void
}

function BorrowDialogContentContainer({ reserve, initialBorrowToken, closeDialog }: BorrowDialogContentContainerProps) {
  const {
    dialogTitle,
    borrowOptions,
    assetsToBorrowFields,
    pageStatus,
    form,
    borrowAsset,
    outputAsset,
    riskAcknowledgement,
    actionsViewState,
    currentPositionOverview,
    updatedPositionOverview,
    relatedCampaigns,
  } = useBorrowDialog({
    reserve,
    initialBorrowToken,
  })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        borrowAsset={borrowAsset}
        outputAsset={outputAsset}
        onProceed={closeDialog}
        proceedText="View in portfolio"
      />
    )
  }

  return (
    <BorrowView
      dialogTitle={dialogTitle}
      selectableAssets={borrowOptions}
      actionsViewState={actionsViewState}
      form={form}
      assetsFields={assetsToBorrowFields}
      borrowAsset={borrowAsset}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      riskAcknowledgement={riskAcknowledgement}
      relatedCampaigns={relatedCampaigns}
    />
  )
}

const BorrowDialogContentContainerWithSuspense = withSuspense(BorrowDialogContentContainer, DialogContentSkeleton)
export { BorrowDialogContentContainerWithSuspense as BorrowDialogContentContainer }
